module.exports = __webpack_public_path__ + "img/150.7023a5b2.jpg";